const lang = {
    ja: {
        'shopping.showBreakdown': '内訳を表示する',
        'shopping.postage': '送料',
        'shopping.subtotal': '小計',
        'shopping.removeProduct': '{nameProduct}は完売しました。支払い手続きを続行するにはカートから削除してください。',
        'shopping.itemCart': '{nameCart}内の商品',
        'shopping.unitPrice': '単価(税込)',
        'shopping.quantity': '数量',
        'shopping.total': '合計',
        'shopping.oderProcedure': '注文手続きへ',
        'shopping.orderHistory': '注文履歴',
        'shopping.orderNumber': '注文番号',
        'shopping.orderDate': '注文日',
        'shopping.paymentMethod': 'お支払方法',
        'shopping.orderDetail': '注文内容',
        'shopping.completeOrder': 'ご注文が完了しました。',
        'shopping.orderContent': '上記の内容で注文する',
        'shopping.oderProcedure2': '注文手続き',
        'shopping.breakdown': '内訳',
        'shopping.selectPaymentMethod': 'お支払方法を選択',
        'shopping.shipInfo': 'お届け先情報',
        'shopping.invoiceNumber': '請求書番号',
        'shopping.totalInvoice': '請求金額合計（税込）',
    },
    en: {
        'shopping.showBreakdown': 'View the breakdown',
        'shopping.postage': 'Shipping cost',
        'shopping.subtotal': 'Subtotal',
        'shopping.removeProduct': '{nameProduct} was sold out. Please delete it from the shopping cart to proceed to payment.',
        'shopping.itemCart': 'Products in the shopping {nameCart}',
        'shopping.unitPrice': 'Unit price (including tax)',
        'shopping.quantity': 'QTY',
        'shopping.total': 'Total',
        'shopping.oderProcedure': 'Proceed to order',
        'shopping.orderHistory': 'Order history',
        'shopping.orderNumber': 'Order number',
        'shopping.orderDate': 'Order date',
        'shopping.paymentMethod': 'Payment method',
        'shopping.orderDetail': 'Order content',
        'shopping.completeOrder': 'Order completed.',
        'shopping.orderContent': 'Order the above.',
        'shopping.oderProcedure2': 'Order procedure',
        'shopping.breakdown': 'Breakdown',
        'shopping.selectPaymentMethod': 'Select payment method',
        'shopping.shipInfo': 'Shipping information',
        'shopping.invoiceNumber': 'Invoice No.',
        'shopping.totalInvoice': 'Total billing amount (including tax)',
    },
};

export default lang;
